module.exports = __webpack_public_path__ + "static/media/Store_Ribbon_purple.75451ef7.png";